













































































































































import store from '../store'
// import zipcelx from 'zipcelx'
import Step1 from '../steps/step-1.vue'
import Step2 from '../steps/step-2.vue'
import Step3 from '../steps/step-3.vue'
import Step4 from '../steps/step-4.vue'
import Step5 from '../steps/step-5.vue'
import { platform } from '@/mla-shared'
import { nativeExcelExport } from '../mla-shared/bridge/NativeApi'

export default {
  data () {
    return {
      title: 'Tool',
      st: 1,
      prev_st: 0,
      savedAlert: false,
      savedStep: 1,
      timeout: 1500
    }
  },
  created: function (this:any) {
    this.st = store.state.st || 1
    store.state.activeTab = 'tool'
  },
  mounted: function () {
    // Prompt to reset data on return to tool
    /*if (localStorage.vuex) {
      store.state.resetData = true
    }*/
  },
  computed: {
    exportData: function () {
      const ss = store.state
      const date = new Date()
      const dateFormatted = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()

      let naming = []
      if (ss.step5.activePreset && ss.st === 5) {
        naming.push([{ value: 'Farm:', type: 'string' }, { value: ss.step5.activePreset.farm || '', type: 'string' }])
        naming.push([{ value: 'Paddock:', type: 'string' }, { value: ss.step5.activePreset.paddock || '', type: 'string' }])
        naming.push([{ value: 'Scenario saved as:', type: 'string' }, { value: ss.step5.activePreset.text || '', type: 'string' }])
      } else {
        naming.push([{ value: 'Farm:', type: 'string' }])
        naming.push([{ value: 'Paddock:', type: 'string' }])
      }
      naming.push([{ value: 'Date completed:', type: 'string' }, { value: dateFormatted, type: 'string' }])
      naming.push([{ value: '', type: 'string' }])

      const step1 = [
        [{ value: 'STEP 1', type: 'string' }],
        [{ value: 'Soil test type:', type: 'string' }, { value: ss.step1.type, type: 'string' }],
        [{ value: 'Phosphorus Buffering Index (PBI):', type: 'string' }, { value: ss.step1.pbi, type: 'number' }],
        [{ value: 'Current ' + ss.step1.type + ' P (mg P/kg):', type: 'string' }, { value: ss.step1.value, type: 'number' }],
        [
          { value: 'Critical soil test level for near maximum pasture growth (mg P/kg):', type: 'string' },
          { value: ss.step1.type === 'Colwell' ? parseFloat(ss.step1.colwellP.toFixed(1)) : parseFloat(ss.step1.olsenP.toFixed(1)), type: 'number' }
        ],
        [{ value: '', type: 'string' }]
      ]

      const step2 = [
        [{ value: 'STEP 2', type: 'string' }],
        [{ value: 'Average growing season length (months):', type: 'string' }, { value: ss.step2.avgGrowingSeason, type: 'number' }],
        [{ value: 'Potential carrying capacity of pasture (DSE/ha):', type: 'string' }, { value: ss.step2.potCarryingCapacity, type: 'number' }],
        [{ value: 'Current stocking rate (DSE/ha):', type: 'string' }, { value: ss.step2.stockingRateCurrent, type: 'number' }],
        [{ value: 'Management target type:', type: 'string' }, { value: ss.step2.type === 'stockingRate' ? 'Stocking rate' : 'Soil fertility', type: 'string' }],
        [{ value: 'Target value ' + (ss.step2.type === 'stockingRate' ? '(DSE/ha):' : '(mg P/kg Soil):'), type: 'string' }, { value: ss.step2.target, type: 'number' }],
        [
          { value: ss.step2.type === 'stockingRate' ? 'Predicted P fertility requirement (mg P/kg soil):' : 'Predicted carrying capacity (DSE/ha):', type: 'string' },
          { value: ss.step2.type === 'stockingRate' ? parseFloat(ss.step2.fertilityTarget.toFixed(1)) : parseFloat(ss.step2.stockingRateTarget.toFixed(1)), type: 'number' }
        ],
        [{ value: '', type: 'string' }]
      ]

      let step3 = [
        [{ value: 'STEP 3', type: 'string' }],
        [{ value: 'Average rainfall (mm):', type: 'string' }, { value: ss.step3.rainfall, type: 'number' }],
        [{ value: 'Soil loss:', type: 'string' }, { value: ss.step3.soilLoss, type: 'string' }],
        [{ value: 'Slope:', type: 'string' }, { value: ss.step3.slope, type: 'string' }],
        [{ value: 'Grazing:', type: 'string' }, { value: ss.step3.grazing, type: 'string' }],
        [{ value: 'Pasture type:', type: 'string' }, { value: ss.step3.pasture, type: 'string' }],
        [{ value: 'P concentration of fertilizer (%):', type: 'string' }, { value: ss.step3.concentration, type: 'number' }],
        [{ value: 'Timeframe — to achieve targets (years):', type: 'string' }, { value: ss.step3.years, type: 'number' }],
      ]
      if (ss.step3.exportResults) {
        step3.push([
          { value: 'Maintenance P required in year 1 of plan (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.maintenance.start.ha.toFixed(1)), type: 'number' }
        ])
        step3.push([
          { value: 'Additional P required in year 1 of plan (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.additional.start.ha.toFixed(1)), type: 'number' }
        ])
        step3.push([
          { value: 'Total P required in year 1 of plan (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.total.start.ha.toFixed(1)), type: 'number' }
        ])
        step3.push([
          { value: 'Maintenance P required in year ' + ss.step3.years + ' of plan (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.maintenance.end.ha.toFixed(1)), type: 'number'
        }])
        step3.push([
          { value: 'Additional P required in year ' + ss.step3.years + ' of plan (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.additional.end.ha.toFixed(1)), type: 'number' }
        ])
        step3.push([
          { value: 'Total P required in year ' + ss.step3.years + ' of plan (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.total.end.ha.toFixed(1)), type: 'number' }
        ])
        step3.push([
          { value: 'Average annual P application rate (kg P/ha/yr):', type: 'string' },
          { value: parseFloat(ss.step3.exportResults.average.ha.toFixed(1)), type: 'number' }
        ])
        step3.push([
          { value: 'Average P fertiliser application rate (kg fertiliser/ha/yr):', type: 'string' },
          { value: ss.step3.exportResults.average.fertiliser, type: 'number' }
        ])
      }
      step3.push([{ value: '', type: 'string' }])

      let step5 = []
      if (ss.step5.exportDataEntry && ss.st === 5) {
        step5.push([{ value: 'STEP 5', type: 'string' }])
        step5.push([{ value: 'Data type', type: 'string' }, { value: 'Value', type: 'string' }, { value: 'Step #', type: 'string' }])
        ss.step5.exportDataEntry.map((d:any) => {
          let value = parseFloat(d.result ? d.result : d.value);
          step5.push([
            { value: d.type, type: 'string' },
            { value: parseFloat(value.toFixed(1)) || '', type: value ? 'number' : 'string' },
            { value: d.step, type: 'number' }
          ])
        })
        step5.push([{ value: '', type: 'string' }])
      }

      let budget = []
      if (ss.step5.exportResults && ss.st === 5) {
        budget.push([
          { value: 'CASH FLOW BUDGET', type: 'string' },
          ...Array.from(Array(11).keys()).map((v:any) => { return { value: 'Year ' + v, type: 'string' } })
        ])
        // CURRENT
        budget.push([{ value: '', type: 'string' }])
        budget.push([
          { value: 'Cash flow budget (current fertiliser regime)', type: 'string' }
        ])
        budget.push([
          { value: 'Stocking rate (DSE/ha)', type: 'string' },
          ...ss.step5.exportResults.current.stockingRate.map((v:any) => { return { value: v, type: 'number' } })
        ])
        budget.push([
          { value: 'Fertiliser rate (kg/ha)', type: 'string' },
          ...ss.step5.exportResults.current.fertiliserRate.map((v:any) => { return { value: v, type: 'number' } })
        ])
        budget.push([
          { value: 'Livestock gross margin income ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.current.livestockGrossCurrent.map((v:any) => { return { value: v, type: 'number' } })
        ])
        budget.push([
          { value: 'Fertiliser cost ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.current.fertiliserCost.map((v:any) => { return { value: parseFloat(v.toFixed(2)), type: 'number' } })
        ])
        budget.push([
          { value: 'Fertiliser spreading cost ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.current.fertiliserSpreadCost.map((v:any) => { return { value: parseFloat(v.toFixed(2)), type: 'number' } })
        ])
        budget.push([
          { value: 'Net cash result ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.current.netCashSpecified.map((v:any) => { return { value: parseFloat(v.toFixed(2)), type: 'number' } })
        ])
        budget.push([
          { value: 'Net cash result (ha)', type: 'string' },
          ...ss.step5.exportResults.current.netCashHa.map((v:any) => { return { value: parseFloat(v.toFixed(2)), type: 'number' } })
        ])
        // PROJECTED
        budget.push([{ value: '', type: 'string' }])
        budget.push([
          { value: 'Projected fertiliser option', type: 'string' }
        ])
        budget.push([
          { value: 'Stocking rate (DSE/ha)', type: 'string' },
          ...ss.step5.exportResults.projected.stockingRate.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Fertiliser rate (kg/ha)', type: 'string' },
          ...ss.step5.exportResults.projected.fertiliserRate.map((v:any) => { return { value: v, type: 'number' } })
        ])
        budget.push([
          { value: 'Expected Soil P fertility level (mg P/kg soil)', type: 'string' },
          ...ss.step5.exportResults.projected.expectedSoilP.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Gross margin per head ($/DSE)', type: 'string' },
          ...ss.step5.exportResults.projected.grossMarginPerHead.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Livestock gross margin income ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.projected.livestockGross.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Fertiliser cost ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.projected.fertiliserCost.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Fertiliser spreading cost ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.projected.fertiliserSpreadCost.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Livestock purchase cost ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.projected.livestockPurchaseCost.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Net cash ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.projected.netCashSpecified.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Net cash ($/ha)', type: 'string' },
          ...ss.step5.exportResults.projected.netCashHa.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        // SUMMARY
        budget.push([{ value: '', type: 'string' }])
        budget.push([
          { value: 'Cumulative cash flow (CCF) summary', type: 'string' }
        ])
        budget.push([
          { value: 'Annual difference in cash flow ($/ha)', type: 'string' },
          ...ss.step5.exportResults.summary.ccfAnnualDifference.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'CCF position ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.summary.ccfPosition.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Interest on CCF ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.summary.interestOnCCF.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'CCF difference with interest ($/specified area)', type: 'string' },
          ...ss.step5.exportResults.summary.ccfDifferenceInterestSpecified.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'CCF differrence with interest ($/ha)', type: 'string' },
          ...ss.step5.exportResults.summary.ccfDifferenceInterestHa.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Additional livestock capital ($/ha)', type: 'string' },
          ...ss.step5.exportResults.summary.additionalLivestockCapital.map((v:any) => { return { value: parseFloat(v.toFixed(1)), type: 'number' } })
        ])
        budget.push([
          { value: 'Internal rate of return (IRR) (%)', type: 'string' },
          ...ss.step5.exportResults.summary.internalReturnRate.map((v:any) => { return { value: v || '', type: v ? 'number' : 'string' } })
        ])
      }

      let data:any[] = [
        ...naming,
        ...step1,
        ...step2,
        ...step3,
        ...step5,
        ...budget
      ]

      return data
    }
  },
  watch: {
    // Save updated values to local storage after step change
    st: function (this:any) {
      store.state.st = this.st
      // Scroll to top of step
      window.scrollTo(0, 0)
      // Show snackbar if step is changed
      if (this.st !== this.prev_st && this.prev_st !== 0 && this.prev_st !== 4) {
        this.savedAlert = true
        this.savedStep = this.prev_st > 0 ? this.prev_st : 1
        // console.log('step ' + this.savedStep + ' saved...')
        if (this.prev_st === 1) {
          store.dispatch('updateStep1', store.state.step1)
        } else if (this.prev_st === 2) {
          store.dispatch('updateStep2', store.state.step2)
        } else if (this.prev_st === 3) {
          store.dispatch('updateStep3', store.state.step3)
        } else if (this.prev_st === 5) {
          store.dispatch('updateStep5', store.state.step5)
        }
        this.$gtm.trackView(('step-' + this.st), '/tool');
      } else {
        // this.savedAlert = false
        return 0
      }
    }
  },
  methods: {
    getPrevSt: function (this:any, st:number) {
      this.prev_st = st
    },
    xlsExport: function (this:any) {
      try {
        const arrData: any[] = this.exportData;
        const filename: string = "p-tool-results-" + (new Date().toISOString().substr(0, 10))
        switch (platform()) {
          case "android":
          case "ios": {
            const rows = arrData.map(i => ({ Step: i[0].value, Item: i[1].value, Value: i[2].value, Results: i[3].value }));
            nativeExcelExport({
              data: rows,
              filename: filename,
              workbook: "Results",
              dialogTitle: "Export Results",
            });
            break;
          }
          default: {
            import('zipcelx').then(zipcelx => {
              const config = {
                filename: filename,
                sheet: {
                  data: arrData,
                }
              };
              zipcelx.default(config);
            });
            break;
          }
        }
      } catch (ex) {
        alert('Error');
        console.error(ex);
      }
    }
  },
  components: { Step1, Step2, Step3, Step4, Step5 },
  store
}
